// extracted by mini-css-extract-plugin
export default {"pageLayout":"Tag-module__pageLayout___ud8M9"};